import { ApolloClient, InMemoryCache } from '@apollo/client';
import axios from 'axios';

/**
 * Api address.
 */
const api = process.env.REACT_APP_API;
axios.defaults.baseURL = api;
axios.interceptors.response.use(response => ((response.data = transformDates(response.data)), response));

const dateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?(Z|[+-]\d{2}:\d{2})$/;

const transformDates = (object: any) => {
    if (typeof object === 'string' && dateRegex.test(object)) object = new Date(object);
    else if (typeof object === 'object') for (const key in object) object[key] = transformDates(object[key]);
    return object;
};

/**
 * Apollo GraphQL Setup
 */

export const apolloClient = new ApolloClient({
    uri: process.env.REACT_APP_GRAPHQL,
    headers: {
        'Content-Type': 'application/json',
        'x-hasura-admin-secret': `${process.env.REACT_APP_GRAPHQL_SECRET}`,
    },
    cache: new InMemoryCache(),
});
